export default {
  text: 'white',
  primary: '#202020',
  secondary: '#f1d224',
  background: 'black',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
